import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useState } from 'react';
import UserFormDrawer from 'v2/pages/Users/Drawers/UserFormDrawer/UserFormDrawer';
import { VisitorGroupAutocompleteOption } from 'v2/utils/visitorGroupAutocomplete';
import UserFormDrawerExistingUser from './UserFormDrawerExistingUser';

const ADD_USER_MODE = {
  new: 'new',
  existing: 'existing'
} as const;

type AddUserMode = (typeof ADD_USER_MODE)[keyof typeof ADD_USER_MODE];

interface Props {
  preSelectedGroup?: VisitorGroupAutocompleteOption | null;
  hideGroupField?: boolean;
  isMaxNumberOfUsersReached?: boolean;
}

const AddUserToGroupDrawer = ({ preSelectedGroup, hideGroupField, isMaxNumberOfUsersReached }: Props) => {
  const { translation } = useTranslation();
  const [mode, setMode] = useState<AddUserMode>(ADD_USER_MODE.new);

  const modeSelector = (
    <FormControl id="add-user-drawer">
      <RadioGroup row value={mode} onChange={(_event, value) => setMode(value as AddUserMode)}>
        <FormControlLabel value={ADD_USER_MODE.new} control={<Radio />} label={translation.new_user} />
        <FormControlLabel value={ADD_USER_MODE.existing} control={<Radio />} label={translation.existing_user} />
      </RadioGroup>
    </FormControl>
  );

  return mode === ADD_USER_MODE.new ? (
    <UserFormDrawer
      preSelectedGroup={preSelectedGroup}
      hideGroupField={hideGroupField}
      topContent={modeSelector}
      isMaxNumberOfUsersReached={isMaxNumberOfUsersReached}
    />
  ) : (
    <UserFormDrawerExistingUser
      preSelectedGroup={preSelectedGroup}
      topContent={modeSelector}
      isMaxNumberOfUsersReached={isMaxNumberOfUsersReached}
    />
  );
};

export default AddUserToGroupDrawer;
